import { render } from "./Pengumuman.vue?vue&type=template&id=bd920aae"
import script from "./Pengumuman.vue?vue&type=script&lang=js"
export * from "./Pengumuman.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__